// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_Sei_x {
  width: 100%;
  max-width: 100vw;
  max-height: 60vh;
  padding: 16px;
}
.fixed_UoSnr {
  width : 100%;
  position : relative;
  height : 100%;
}
.logLabel_OOCDY {
font-family: Inter;
font-weight: 400;
font-size: 13px;
line-height: 20px;
letter-spacing: 0%;
vertical-align: middle;
color: #67798E;
margin-bottom: 16px;
}
.logLabelError_HQrI7 {
  font-family: Inter;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #AA2A30;
  margin-bottom: 16px;
  }`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/actions/logUpload/LogUploadForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;AACA,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,sBAAsB;AACtB,cAAc;AACd,mBAAmB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB","sourcesContent":[".form {\n  width: 100%;\n  max-width: 100vw;\n  max-height: 60vh;\n  padding: 16px;\n}\n.fixed {\n  width : 100%;\n  position : relative;\n  height : 100%;\n}\n.logLabel {\nfont-family: Inter;\nfont-weight: 400;\nfont-size: 13px;\nline-height: 20px;\nletter-spacing: 0%;\nvertical-align: middle;\ncolor: #67798E;\nmargin-bottom: 16px;\n}\n.logLabelError {\n  font-family: Inter;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0%;\n  vertical-align: middle;\n  color: #AA2A30;\n  margin-bottom: 16px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `form_Sei_x`,
	"fixed": `fixed_UoSnr`,
	"logLabel": `logLabel_OOCDY`,
	"logLabelError": `logLabelError_HQrI7`
};
export default ___CSS_LOADER_EXPORT___;
